import React from 'react'

const HoveredSiteContext = React.createContext(null)

export default HoveredSiteContext
